module.exports = __webpack_public_path__ + "img/end_bg.718aebde.png";